
import useVendor from "../../hooks/useVendor";

import {useState} from 'react'
import MenuItem from '@material-ui/core/MenuItem';
import {TextField} from "@mui/material";
import {isFunction} from "lodash";



export const VendorSelect = ({setValidationStatus}) => {

    
    const {vendors, loading} = useVendor();

    // console.log(vendors)

    
    
    //console.log(vendors)
    const Initial = {
        'id': '',
        'Name': 'Tout'
    }

    var AllVendor = []
    AllVendor.push(Initial)
    AllVendor.push(...vendors)
    
    // const [first] = OPTIONS;
    const [first2] = AllVendor;

    const [selected, setSelected] = useState(first2?.Name);

    const handleChange = (change) => { 
        // console.log("object ="+ JSON.stringify(change));
        setSelected(change)
        isFunction(setValidationStatus) && setValidationStatus(change)
    }    
    
    // console.log( handleChange(value))
    // console.log(selected[first2?.Name])
    // console.log(AllVendor)

    // const handleTest = (e) => { 
    //     handleChange(e.target.value)
    // }    

    return (
        <>
            <TextField
                fullWidth
                select
                label={'Vendor'}
                value={selected}
                style={{minWidth:300}}
                onChange={ev => handleChange(ev.target.value)}
            >
                {
                    AllVendor.map(one => (
                        <MenuItem key={one.id} value={one.id} >
                            {one.Name}
                        </MenuItem>
                    ))
                }

            </TextField>

        </>
    )
}
